export default __webpack_public_path__ + "static/media/Save.e4de6051.svg";